import React, { Component } from 'react';
import { Link } from 'react-router-dom';

export default class InventoryBreadCrumbs extends Component {

  render() {
    const { records } = this.props;
    return (
      <nav>
        <div className="breadcrumbs">
          <div className="breadcrumb">
            <Link to="/">Home</Link>
          </div>
          <div className="breadcrumb">
            {records &&
              <Link to="/inventory/list">Inventory List</Link>
            }
            {!records &&
              <span>Inventory List</span>
            }
          </div>
          {records &&
            <div className="breadcrumb">
              <span>Inventory Records</span>
            </div>
          }
        </div>
      </nav>
    )
  }
}
